import axiosCall from './interceptor';
import URL, { getTemplateVersion, strictEncode } from '../helper';
import { syncToStorage } from './complexDocumentsAPI';
import { deepCopy } from '../javascript';
import { COMPLEX_DOCUMENT_VERSION, DESIGN_TYPE } from '../complexDocumentConstants';
import { putIndexedDBData } from '../indexedDBUtil';
import axios from 'axios';

export const getComplexEmail = async (id, version = COMPLEX_DOCUMENT_VERSION.DRAFT) => {
  let url = `${URL.DESIGN_SYSTEM_URL}emailTemplate/${id}`;
  if (version === COMPLEX_DOCUMENT_VERSION.QA_READY) {
    url = `${URL.TRANSACTION_SYSTEM_URL}qaReadyEmailTemplate?draftTemplateId=${id}&includeFlows=true`;
  } else if (version === COMPLEX_DOCUMENT_VERSION.PUBLISHED) {
    url = `${URL.TRANSACTION_SYSTEM_URL}publishedEmailTemplate?draftTemplateId=${id}&includeFlows=true`;
  }
  let response = await axiosCall('get', url);
  if (version === COMPLEX_DOCUMENT_VERSION.DRAFT) {
    putIndexedDBData('complexDocument', response.data.data);
    return response.data;
  } else {
    console.log({ response });
    return {
      statusCode: response.data?.statusCode,
      data: response.data?.data[0],
    };
  }
};

export const getEmailStandaloneBlock = async (id, version = COMPLEX_DOCUMENT_VERSION.DRAFT, updateSession = true) => {
  let url = `${URL.DESIGN_SYSTEM_URL}email/standalone/block/${id}`;
  if (version === COMPLEX_DOCUMENT_VERSION.QA_READY) {
    url = `${URL.TRANSACTION_SYSTEM_URL}email/qaReadyBlock?draftBlockId=${id}`;
  } else if (version === COMPLEX_DOCUMENT_VERSION.PUBLISHED) {
    url = `${URL.TRANSACTION_SYSTEM_URL}email/publishedBlock?draftBlockId=${id}`;
  }
  let response = await axiosCall('get', url);
  if (version === COMPLEX_DOCUMENT_VERSION.DRAFT) {
    updateSession && putIndexedDBData('complexDocument', response.data.data);
    return response.data;
  } else {
    let blockList;
    if (response.data?.statusCode === 2505) {
      blockList = { ...response.data?.data[0], blocks: response.data?.data[0].blockDTOList }
    } 
    return {
      statusCode: response.data?.statusCode,
      data: blockList
    };
  }
}

export const patchComplexEmail = async (payload, refrencedFlowId, callback) => {
  const updateFlow = payload.flows.map(list => {
    if (list.isStandalone) {
      return {
        flowId: list.flowId,
        isStandalone: list.isStandalone,
        orderNumber: list.orderNumber,
        isDeleted: list?.isDeleted ? true : false,
        uuid: list?.uuid,
      };
    }
    return list;
  });

  const newPayLoad = { ...payload, flows: updateFlow };

  const url = `${URL.DESIGN_SYSTEM_URL}emailTemplate/${payload.documentId}`;
  let syncData = undefined;
  newPayLoad.documentId = undefined;
  let response = await axiosCall('put', url, newPayLoad);
  if (response?.data?.statusCode === 703) {
    syncData = response.data.data;
    syncData && callback && (await callback(syncData));
  } else {
    console.log('Auto save unsuccessful!! ', response);
  }
  return syncToStorage(syncData, deepCopy(payload), refrencedFlowId);
};

export const patchComplexEmailBlock = async (payload) => {
  const url = `${URL.DESIGN_SYSTEM_URL}email/standalone/block`;
  let syncData = undefined;
  let response = await axiosCall('put', url, { "parentBlockId": payload.documentId, "blocks": payload.flows[0].blocks, style:payload.flows[0].style });
  if(response?.data?.statusCode === 2502) {
    response.data.data.flows = [{ "blocks": response.data.data }];
    syncData = response.data.data;
  } else {
    console.log("Auto save unsuccessful!! ", response);
  }
  return syncToStorage(syncData, payload, undefined, false);
}

export const getComplexEmailStatus =  async(id,type)=>{
   let url;
   if(type === DESIGN_TYPE.DOCUMENT){
      url = `${URL.DESIGN_SYSTEM_URL}emailTimestamp?draftEmailId=${id}`; 
   }
   else if (type === DESIGN_TYPE.BLOCK){
      url = `${URL.DESIGN_SYSTEM_URL}email/standalone/blockTimestamp?draftBlockId=${id}`;
   }
   const response = axiosCall('get',url);
   return response;
}

export const emailSendToTesting = async (id, design = DESIGN_TYPE.DOCUMENT) => {
  let url = `${URL.DESIGN_SYSTEM_URL}emailTemplate/moveToQAReady?id=${id}`;
  if (design === DESIGN_TYPE.BLOCK) {
    url = `${URL.DESIGN_SYSTEM_URL}email/standalone/block/moveToQAReady?blockId=${id}`;
  }
  if (url !== '') {
    let response = await axiosCall('post', url);
    console.log({ response });
    return response.data;
  }
  return null;
}

export const moveToQaComplete = async (id, design = DESIGN_TYPE.DOCUMENT) => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}emailTemplate/moveToQAComplete?id=${id}`;
  if (design === DESIGN_TYPE.BLOCK) {
    url = `${URL.TRANSACTION_SYSTEM_URL}email/block/qaready?id=${id}&qareadystatus=qacomplete`;
  }
  if (url !== '') {
    let response = await axiosCall('patch', url);
    console.log({ response });
    return response.data;
  }
  return null;
}

export const publishDesign = async (id, design = DESIGN_TYPE.DOCUMENT) => {
  let url = `${URL.TRANSACTION_SYSTEM_URL}emailTemplate/publish?id=${id}`;
  if (design === DESIGN_TYPE.BLOCK) {
    url = `${URL.TRANSACTION_SYSTEM_URL}email/block/publish?id=${id}`;
  }
  if (url !== '') {
    let response = await axiosCall('post', url);
    console.log({ response });
    return response.data;
  }
  return null;
}

export const createEmailTemplate = async (payload) => {
  const url = `${URL.DESIGN_SYSTEM_URL}emailTemplate`;
  let response = await axiosCall('post', url, payload);
  return response.data;
}

export const createEmailTemplateWithBlock = async (payload) => {
  const url = `${URL.DESIGN_SYSTEM_URL}importEmailTemplate`;
  let response = await axiosCall('post', url, payload);
  return response.data;
}

export const FetchEmailTemplatesBycategory = async (payload, cancelTokenSource) => {
  const params = new URLSearchParams(payload);
  const url = `${URL.DESIGN_SYSTEM_URL}emailTemplateByCategory?${params.toString()}`;
  let response = await axiosCall('get', url, { cancelToken: cancelTokenSource?.token });
  return response.data;
};

export const fetchAllEmailTemplates = async (payload) => {
  const params = new URLSearchParams(payload);
  const url = `${URL.DESIGN_SYSTEM_URL}emailTemplate?${params.toString()}`;
  let response = await axiosCall('get', url);
  return response.data;
}

export const deleteComplexMailTemplate = async (id) => {
  const url = `${URL.DESIGN_SYSTEM_URL}emailTemplate?id=${id}`;
  let response = await axiosCall('delete', url);
  return response.data;
}

export const fetchQAReadyTemplates = async (payload) => {
  const params = new URLSearchParams(payload);
  const url = `${URL.TRANSACTION_SYSTEM_URL}qaReadyEmailTemplate?${params.toString()}`;
  let response = await axiosCall('get', url);
  return response.data;
}

export const FetchReferencedBycategory = async (payload) => {
  const params = new URLSearchParams(payload);
  const url = `${URL.DESIGN_SYSTEM_URL}email/standalone/blockByCategory?${params.toString()}`;
  let response = await axiosCall('get', url);
  return response.data;
}

export const deleteReferencedBlock = async (id) => {
  const url = `${URL.DESIGN_SYSTEM_URL}email/standalone/block?id=${id}`;
  let response = await axiosCall('delete', url);
  return response.data;
}

export const createEmailReferencedBlock = async (payload) => {
  const url = `${URL.DESIGN_SYSTEM_URL}email/standalone/block`;
  let response = await axiosCall('post', url, payload);
  return response.data;
}

export const fetchAllStandaloneBlock = async (page, referenced, categoryIds, name, tags,rgpermission, forApproval) => {
  const params = {
    ...(page && { page, limit: 8 }),
    ...(rgpermission && { rgPermission: rgpermission }),
    ...(forApproval && { qaReadyStatus: 'qacomplete' }),
    ...(categoryIds && { categoryIds }),
    ...(name && { name }),
    ...(tags && { tags }),
   };
  const uriComponent = Object.keys(params).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&');
  let url = `${URL.DESIGN_SYSTEM_URL}email/standalone/block?${uriComponent}`;
  if (forApproval) {
    url = `${URL.TRANSACTION_SYSTEM_URL}email/qaReadyBlock?${uriComponent}`;
  }
  let response = await axiosCall('get', url);
  return response.data;
}

export const updateEmailResourceNames = async (data, isStandalone = false) => {
  const uriComponent = Object.keys(data).map(key => `${strictEncode(key)}=${strictEncode(data[key])}`).join('&');
  let url = `${URL.DESIGN_SYSTEM_URL}emailTemplate/name?${uriComponent}`;
  if (isStandalone) {
    url = `${URL.DESIGN_SYSTEM_URL}email/standalone/block/name?${uriComponent}`;;
  }
  let response = await axiosCall('patch', url);
  return response.data;
}

export const verifiedFromAddressList = async (status = 'verified') => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}fromAddress?status=${status}`;
  let response = await axiosCall('get', url);
  return response.data;
}

export const patchEmailSubject = async (emailTemplateId, subject) => {
  const url = `${URL.DESIGN_SYSTEM_URL}emailTemplate`;
  const payload = {
    emailTemplateId,
    subject
  };
  let response = await axiosCall('patch', url, payload);
  return response.data;
}

export const patchFromAddress = async (emailTemplateId, fromAddressId) => {
  const url = `${URL.DESIGN_SYSTEM_URL}emailTemplate`;
  const payload = {
    emailTemplateId,
    fromAddressId
  };
  let response = await axiosCall('patch', url, payload);
  return response.data;
}

export const patchEnvFromAddress = async (emailTemplateId, fromAddressId, env) => {
  const payload = {
    fromAddressId,
    env: env,
  };
  const uriComponent = Object.keys(payload).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(payload[key])}`).join('&');
  const url = `${URL.TRANSACTION_SYSTEM_URL}envFromAddress/${emailTemplateId}?${uriComponent}`;
  let response = await axiosCall('patch', url, payload);
  return response.data;
};

export const patchAttachments = async (emailTemplateId, attachment) => {
  const url = `${URL.DESIGN_SYSTEM_URL}emailTemplate`;
  const payload = {
    emailTemplateId,
    attachment
  };
  let response = await axiosCall('patch', url, payload);
  return response.data;
}

export const deleteAttachment = async (attachmentId) => {
  const url = `${URL.DESIGN_SYSTEM_URL}emailAttachment?attachmentId=${attachmentId}`;
  let response = await axiosCall('delete', url);
  return response.data;
}

export const sendTestEmailAPI = async (payload) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}sendTestEmail/${payload.templateId}`;
  let response = await axiosCall('post', url, payload);
  return response.data;
}

export const fetchManageTags = async (payload) => {
  console.log('payload',payload)
  const searchParam = new URLSearchParams(payload);
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/tags`;
  let response = await axiosCall('get', url,searchParam);
  return response.data;
}

export const getMasterEmails = async payload => {
  const params = new URLSearchParams(payload);
  const url = `${URL.DESIGN_SYSTEM_URL}masterEmails?${params}`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const getMasterEmailsByCategory = async cancelTokenSource => {
  const url = `${URL.DESIGN_SYSTEM_URL}masterEmailsByCategory?countPerCategory=4`;
  const response = await axiosCall('get', url,{cancelToken : cancelTokenSource?.token});
  return response.data;
};

export const getMasterlanguageList = async data => {
  const url = `${URL.BASE_URL}masterLanguages`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const releaseEmailDesignbroadcast = async (payload,id) => {
  const params = new URLSearchParams(id);
  const url = `${URL.DESIGN_SYSTEM_URL}email/broadcast?${params}`;
  const response = await axiosCall('post', url, payload);
  return response.data;
};

export const showDesignbroadcast = async payload => {
  const url = `${URL.DESIGN_SYSTEM_URL}email/broadcast/display`;
  const response = await axiosCall('patch', url, payload);
  return response.data;
};

export const getEmailDisplayStatus = async templateId => {
  const url = `${URL.DESIGN_SYSTEM_URL}masterEmails/${templateId}/display`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const emailTemplatesByGroup = async (groupId) => {
  const url = `${URL.DESIGN_SYSTEM_URL}emailTemplate?groupId=${groupId}`;
  let response = await axiosCall('get', url);
  return response.data;
}

export const emailBlocksByGroup = async (groupId) => {
  const url = `${URL.DESIGN_SYSTEM_URL}email/standalone/block?groupId=${groupId}`;
  let response = await axiosCall('get', url);
  return response.data;
}

export const translateEmailTemplate = async (data) => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/email/translate?id=${data.templateId}&language=${data.languageCode}`;
  let response = await axiosCall('post', url);
  return response.data;
}

export const translateEmailBlock = async (data) => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/email/translate/block?id=${data.templateId}&language=${data.languageCode}`;
  let response = await axiosCall('post', url);
  return response.data;
}

export const updateTags = async (data) => {
  const url = `${URL.DESIGN_SYSTEM_URL}dynamic/tags`;
  let response = await axiosCall('patch', url, data);
  return response.data;
};

export const getSelectedEmailTemplate = async data => {
  const url = `${URL.DESIGN_SYSTEM_URL}emailTemplate?ids=${data}&includeFlows=true`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const getEmailBlockFolderList = async payload => {
  const params = new URLSearchParams(payload);
  let url = `${URL.DESIGN_SYSTEM_URL}email/standalone/block?${params}`;
  let response = await axiosCall('get', url);
  return response.data;
};

export const getPreviewForDesign = async (id, payload) => {
  console.log({ id, payload });
  let url = `${URL.TRANSACTION_SYSTEM_URL}email/preview/${id}`;
  let response = await axiosCall('post', url, payload);
  return response;
}
export const getPublishedEmailTemplates = async payload => {
  const params = new URLSearchParams(payload);
  const url = `${URL.TRANSACTION_SYSTEM_URL}publishedEmailTemplate?${params}`;
  const response = await axiosCall('get', url);
  return response.data;
}

export const uploadComplexEmailDataSet = async (name, payload) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}live/uploadDataSet?batchName=${strictEncode(name)}&channel=email`;
  const response = await axiosCall('post', url, payload);
  return response.data;
}

export const getComplexEmailDashboardChartData = async () => {
  const searchParam = new URLSearchParams({ limit: 12 });
  const url = `${URL.TRANSACTION_SYSTEM_URL}fetchEmailTrends?${searchParam}`;
  const response = await axiosCall('get', url); 
  return response.data;
};

export const getComplexEmailTransactionStats = async (data) => {
  const searchParam = new URLSearchParams(data.payload);
  const env = getTemplateVersion(data.env); 
  const url = `${URL.TRANSACTION_SYSTEM_URL}${env}/fetchEmailTransactionStats?${searchParam}`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const getTopTenFailureComplexEmailDetails = async (data) => {
  const searchParam = new URLSearchParams(data.payload);
  const env = getTemplateVersion(data.env); 
  const url = `${URL.TRANSACTION_SYSTEM_URL}${env}/fetchTopTenFailedEmails?${searchParam}`;
  const response = await axiosCall('get', url);
  return response.data;
};

export const getFailedComplexEmails = async (data) => {
  const searchParam = new URLSearchParams(data.payload);
  const env = getTemplateVersion(data.env); 
  const url = `${URL.TRANSACTION_SYSTEM_URL}${env}/fetchFailedEmails?${searchParam}`;
  const response = await axiosCall('get', url); 
  return response.data;
};

export const sendEmailsFromDraft = async (id, payload) => {
  const url = `${URL.TRANSACTION_SYSTEM_URL}draftBulkUpload?channel=email`;
  let response = await axiosCall('post', url, payload, true, false);
  return response.data;
}

export const postEmailDataSetOverride = async (documentId, payload) => {
  const url = `${URL.DESIGN_SYSTEM_URL}emailTemplate/dataSetOverride/${documentId}`;
  const response = await axiosCall('put', url, payload);
  return response.data;
};

